'use strict';

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-integer");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.find");

var _classCallCheck = require("/home/circleci/afex-nigeria/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/afex-nigeria/node_modules/@babel/runtime/helpers/createClass");

var cheerio = require('cheerio');

var HtmlTableToJson =
/*#__PURE__*/
function () {
  function HtmlTableToJson(html, opts) {
    _classCallCheck(this, HtmlTableToJson);

    if (typeof html !== 'string') {
      throw new TypeError('html input must be a string');
    }

    this.html = html;
    this.opts = opts;
    this._$ = cheerio.load(this.html);
    this._results = [];
    this._headers = [];
    this._count = null;

    this._process();
  }

  _createClass(HtmlTableToJson, [{
    key: "_process",
    value: function _process() {
      var _this = this;

      if (this._results.length) {
        return this._results;
      }

      this._$('table').each(function (i, element) {
        return _this._processTable(i, element);
      });

      return this._results;
    }
  }, {
    key: "_processTable",
    value: function _processTable(tableIndex, table) {
      var _this2 = this;

      this._results[tableIndex] = [];

      this._buildHeaders(tableIndex, table);

      this._$(table).find('tr').each(function (i, element) {
        return _this2._processRow(tableIndex, i, element);
      });

      this._pruneEmptyRows(tableIndex);
    }
  }, {
    key: "_processRow",
    value: function _processRow(tableIndex, index, row) {
      var _this3 = this;

      this._results[tableIndex][index] = {};

      this._$(row).find('td').each(function (i, cell) {
        _this3._results[tableIndex][index][_this3._headers[tableIndex][i] || i + 1] = _this3._$(cell).text().trim();
      });
    }
  }, {
    key: "_buildHeaders",
    value: function _buildHeaders(index, table) {
      var _this4 = this;

      this._headers[index] = [];

      this._$(table).find('tr').each(function (i, row) {
        _this4._$(row).find('th').each(function (j, cell) {
          _this4._headers[index][j] = _this4._$(cell).text().trim();
        });
      });
    }
  }, {
    key: "_pruneEmptyRows",
    value: function _pruneEmptyRows(tableIndex) {
      this._results[tableIndex] = this._results[tableIndex].filter(function (t) {
        return Object.keys(t).length;
      });
    }
  }, {
    key: "count",
    get: function get() {
      return Number.isInteger(this._count) ? this._count : this._count = this._$('table').get().length;
    }
  }, {
    key: "results",
    get: function get() {
      return this._results;
    }
  }, {
    key: "headers",
    get: function get() {
      return this._headers;
    }
  }], [{
    key: "factory",
    value: function factory(html, opts) {
      return new HtmlTableToJson(html, opts);
    }
  }]);

  return HtmlTableToJson;
}();

module.exports = HtmlTableToJson;